<template>
    <div id="reminder">
        <b-modal
            v-model="show"
            size="lg"
            title="Edit Reminder"
            class="modal-alerts"
            :ok-only="false"
            ok-title="Save"
			@ok="saveReminder"
        >
		<div>This is a reminder</div>
        <b-container fluid>
				<b-row>
					<b-col>
                        <b-form-group label="Part Code" label-for="codice">
                            <b-form-input id="codice" v-model="remdata.codice" readonly></b-form-input>
                        </b-form-group>
                        <b-form-group label="Part Description" label-for="descrizione">
                            <b-form-input id="descrizione" v-model="remdata.descrizione" readonly></b-form-input>
                        </b-form-group>
                        <b-form-group label="When" label-for="when">
                            <b-form-input id="when" v-model="when" type="date"></b-form-input>
                        </b-form-group>
                        <!-- <b-form-group label="Email" label-for="who">
                            <b-form-input id="who" v-model="who" type="email"></b-form-input>
                        </b-form-group> -->
                        <b-form-group label="Message" label-for="what">
                            <b-form-input id="what" v-model="what"></b-form-input>
                        </b-form-group>
                    </b-col>
				</b-row>
			</b-container>
        </b-modal>
    </div>
</template>

<script>
import { API } from "@/api.js";
export default {
    components: { },
    props: {
        remdata: Object,
        remshow: Number,
    },
    data() {
        return {
            show: false,
            when: '',
            what: '',
            who: '',
        };
    },
    watch: {
        // whenever question changes, this function will run
        remshow(n) {
            if(n>0)
                this.show = true
        }
    },
    methods: {
        saveReminder(){
            console.log("saveReminder")
            API.savememo(this.when, this.what,`Reminder for ${this.remdata.codice} - ${this.remdata.descrizione}`)
        }
    },
}
</script>
